<template>
  <v-container class="container-bg-color pa-0" fluid fill-height>

    <v-row align="center" style="height:100%" no-gutters>
      <v-col cols="12" sm="12" md="6" align="center" class="login-bg d-none d-md-flex d-sm-none"          >
      </v-col>
      <v-col cols="12" sm="12" md="6" align="center" class="pa-12">
        <a class="text-decoration-none" href="/">
          <!-- <v-avatar size="100" class="mb-10">
            <img src="@/assets/images/aafmc-logo.png"/>
          </v-avatar> -->
          <img src="@/assets/images/aafmc-logo1.png" width="150"/>
        </a>

        <div class="mx-auto pt-6" style="width:fit-content;text-align:left">
          <slot>
          </slot>
          <p class="text-center mt-12">
            <a href="https://vm.tiktok.com/ZSNdhCPu5" class="social" aria-label="tiktok" title="tiktok" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" fill="currentColor" class="v-icon bi bi-tiktok" viewBox="0 0 16 16">
                <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z" fill="#333333"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/AAFMofficial/" class="social" aria-label="facebook" title="facebook" target="_blank">
              <v-icon
                x-large
                color="#39599f"
              >
                mdi-facebook
              </v-icon>
            </a>
            <a href="https://www.instagram.com/aafmcorp/?__coig_restricted=1" class="social" aria-label="instagram" title="instagram" target="_blank">
              <v-icon
                x-large
                color="#000"
              >
                mdi-instagram
              </v-icon>
            </a>
            <a href="https://www.linkedin.com/company/104778135/admin/dashboard/" class="social" aria-label="instagram" title="linkedIn" target="_blank">
              <v-icon
                x-large
                color="#2867b2"
              >
                mdi-linkedin
              </v-icon>
            </a>
            <!-- <a href="#" class="social" aria-label="twitter" title="twitter" target="_blank">
              <v-icon
                x-large
                color="#55ACEE"
              >
                mdi-twitter
              </v-icon>
            </a> -->
          </p>

        </div>
        <!-- <div class="mt-16">
          <a class="text-decoration-none" href="/">
            <img class="mx-auto" src="@/assets/images/aafmc-logo.png" width="50"/>
          </a>
        </div>

        © 2022 All Rights Reserved. -->
      </v-col>
    </v-row>
    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>

  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import { required } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import SnackBar from '@/components/snackbar/SnackBar.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  export default {
    name: 'Login',
    data: () => ({
      passShow: false,
      dialog: {
        show: false,
        title: 'Delete Item',
        body: 'Are you sure you want to delete this item?',
        type: '',
        item: {},
        cancelBtnWithAction: true,
        confirmBtn: 'Yes',
        cancelBtn: 'Cancel'
      },
      user: {
        username: '',
        password: ''
      },
      error:{
        show: false,
        status: '',
        error: '',
        messages: {}
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      loading: false
    }),
    computed: {
      ...mapGetters(['getFirstLoad', 'getCategories', 'getUsers', 'capitalise']),
    },
    methods: {
      doConfirm () {
        this.dialog.show = false
        this.$store.commit('setCurrentUser', { currentUser: this.dialog.user })
        this.$router.push({ name: 'tables' })
      },
      doCancel () {
        this.dialog.show = false
      },
      showLoginDialog (user) {
        this.dialog = {
          show: true,
          title: "Enter "+this.capitalise(user.nickname)+"'s PIN",
          body: '',
          type: 'close',
          user: user,
          confirmBtn: 'Login',
          cancelBtn: 'Cancel'
        }
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
    },
    mounted() {
    },
    components: {
      SnackBar,
      // ValidationProvider,
      // ValidationObserver,
    },
  }
</script>
